import React, { useContext, useState, useEffect } from "react"
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import Form from "../../components/Forms/Form";
import { useLocation, Link } from "react-router-dom";
import Loader from "../../components/Loader";
import RowLicence from "./RowLicence";
import { PaloLicenceColumn } from "../../components/headerContent";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/Table";
import { useTranslation } from "react-i18next";

export default function Licence() {
  const { apiUrl, user } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search);
  const paloId = searchParams.get("paloId");
  const referrer = searchParams.get("referrer");
  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation();

  // Request to get all licences and set a new array
  const getAllLicences = async () => {

    const responses = await axios.all([
      axios.get(`${apiUrl}license/palo/`, {
        method: "GET",
        withCredentials: true,
      }),
      axios.get(`${apiUrl}eqptpalo/`, {
        method: "GET",
        withCredentials: true,
      }),
    ]);


    // set array
    const licences = responses[0].data;
    const eqpt = responses[1].data;

    // set an empty array to stock famille object
    let family = [];
    eqpt.forEach((equipement) => {
      family.push(equipement.famille);
    });

    // create an array by set the equipement id in key and famille who matched
    const familiesById = eqpt.reduce((result, equipement) => {
      result[equipement.id] = equipement.famille;
      return result;
    }, {});

    // add famille in licences by match palo.id
    const licenceFamily = licences.map((licence) => {
      const famille = familiesById[licence.palo_id];
      return { ...licence, famille };
    });

    return licenceFamily
  };

  const licences = useQuery({
    queryKey: ["licences"],
    queryFn: getAllLicences
  });

  useEffect(() => {
    if (licences.data !== undefined && !licences.data.includes("No data") && licences.data[0].data !== "No license palo found") {
      if (paloId) {
        const filteredData = licences.data.filter(licence => licence.license_id === paloId);
        setFilteredData(filteredData);
      } else {
        setFilteredData(licences.data);
      }
    }
  }, [licences.data, paloId]);

  // Request to get all sites
  const getAllSites = async (entreprise) => {

    if (user.entrepriseId) {
      const res = await axios(`${apiUrl}equipement/sites/${entreprise}`, {
        method: "GET",
        withCredentials: true,
      })
      return res.data;
    }
  };

  const sites = useQuery({
    queryKey: ['sites', user.entrepriseId],
    queryFn: () => getAllSites(user.entrepriseId)
  })

  useEffect(() => {
    queryClient.invalidateQueries(["sites", user.entrepriseId])
  }, [user.entrepriseId])

  if (licences.isError) {
    return (
      <>
        {!licences.isLoading ? (
          <div className="ecp-container">
            <div className="ecp-container-content-error">
              <div className="error-container">
                <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                <div className="error-container-text">
                  <h1 className="page-title">
                    {t("Aucune donnée disponible")}
                  </h1>
                  <p className="page-link_home">
                    <Link to="/"> {t("Revenir à l'accueil")}</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Loader />
        )
        }
      </>
    )
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        {!licences.isLoading ? (
          <>
            <div className="ecp-container-content-header">
              <div className="ecp-container-content-header-title">
                <div className="page-title page-logo">
                  <img src="../assets/palo_logo.png" alt="Logo de Lenovo" />
                  <h1 className="page-title">{t('Licences Palo Alto')}</h1>
                </div>
              </div>
            </div>
            <section className="page-section mt-2">
              {paloId && (
                <div className="page-title page-link-timeline">
                  <Link to={`/${referrer}`} className="buttons-ecp button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</Link>
                </div>
              )}
            </section>
            <div className='cato-content-table mt-1'>
              {filteredData.length > 0 ? (
                <Table
                  tableData={filteredData}
                  tableColumns={PaloLicenceColumn}
                  rowComponent={RowLicence}
                  sites={sites}
                />
              ) : (
                <div className="ecp-container">
                  <div className="ecp-container-content-error">
                    <div className="error-container">
                      <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                      <div className="error-container-text">
                        <h1 className="page-title">
                          {t("Aucune donnée disponible")}
                        </h1>
                        <p className="page-link_home">
                          <Link to="/"> {t("Revenir à l'accueil")}</Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}

